var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckGreenCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#62CDB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7287 8.84015C18.1484 9.35308 18.0728 10.1091 17.5599 10.5288L10.1194 16.6165L6.35147 12.8486C5.88284 12.3799 5.88284 11.6201 6.35147 11.1515C6.8201 10.6829 7.5799 10.6829 8.04853 11.1515L10.2806 13.3836L16.0401 8.67129C16.553 8.25161 17.3091 8.32722 17.7287 8.84015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreenCircle);
export default __webpack_public_path__ + "static/media/icon-check-green-circle.ad836e13b45afbd06308066dced01e35.svg";
export { ForwardRef as ReactComponent };